const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000

const isLatestData = (latestRecordDate?: string) => {
  if (!latestRecordDate) {
    return false
  }

  const diffInDays = Math.round((new Date().getTime() - new Date(latestRecordDate).getTime()) / ONE_DAY_IN_MILLISECONDS)
  return diffInDays <= 7
}

export { isLatestData }
